import ufeApi from 'services/api/ufeApi';

// https://jira.sephora.com/wiki/display/ILLUMINATE/AddressValidationAPI

function validateAddress(params) {
    const url = '/api/util/address/validate';

    // Flag-agnostic passthrough: POST the params the caller built and return the request promise
    // directly. ufeApi.makeRequest already rejects when the response carries an errorCode, so no
    // manual error handling is needed here. AVS Loqate v2 request enrichment (channel:'UFE', locale,
    // cartContext) is added by the caller AddressActions.validateAddress only when avsLoqateV2
    // is on, so the flag-off request stays byte-for-byte legacy. Note: `source` (e.g. 'paypal') is a
    // UFE-internal routing flag and is deliberately NOT sent — AVS AddressValidationInput has no such field.
    return ufeApi.makeRequest(url, {
        method: 'POST',
        body: JSON.stringify(params)
    });
}

export default validateAddress;
